import {
  hasOwnProp,
  isFunction
} from '@/utils'

function isNotChrome (): boolean {
  if (typeof window.chrome === 'undefined') {
    console.warn(
      'Available in "https://www.google.com/chrome/" Chrome for Desktop PC only'
    )
  }

  return Boolean(typeof window.chrome === 'undefined' || 
    navigator.userAgent.match(/Android/i) || 
    navigator.userAgent.match(/iPhone/i) || 
    navigator.userAgent.match(/iPad/i) || 
    navigator.userAgent.match(/iPod/i) || 
    navigator.userAgent.match(/webOS/i) || 
    navigator.userAgent.match(/BlackBerry/i) || 
    navigator.userAgent.match(/Windows Phone/i)
  )
}

function isNotXPnacl (): boolean {
  return Boolean(
    !hasOwnProp(navigator.mimeTypes, 'application/x-pnacl') ||
    !hasOwnProp(navigator.mimeTypes, 'application/vxg_media_player')
  )
}

function isIncognito (): void {
  const fs = window.RequestFileSystem || window.webkitRequestFileSystem
  if (fs) {
    fs(window.TEMPORARY, 100,
      function () {},
      function () {
        alert('You have opened this page in incognito mode. \nPlease open it in a regular tab.')
      }
    )
  }
}

/**
 * 
 * @param {string} PORT
 */
function webSocket (PORT: string): any {
  return new Promise((resolve, reject) => {
    const socket = new WebSocket(`ws://127.0.0.1:${PORT}/`)
    socket.onmessage = function (e) {
      console.log(e)
    }
    socket.onopen = function () {
      socket.close()
      resolve(socket)
    }
    socket.onerror = function () {
      reject('WebSocket: Connection Failed!')
    }
  })
}

/**
 * 
 * @param {object} self
 */
function createEmbedElement (self: any): any {
  const embed = document.createElement('embed')
    embed.setAttribute('id', self.id)
    embed.setAttribute('src', self.x.nmf_src)
    embed.setAttribute('path', self.x.nmf_path)
    embed.setAttribute('type', 'application/x-pnacl')
  return embed
}

/**
 * Embed Plugin Player.
 * 
 * @param {string} id
 * @param {object} options
 */
function Playback (id: string, options: any): any {
  const VERSION: string = '1.8.51'
  const PORT: string = '8778'

  if (isNotChrome() || isNotXPnacl()) {
    return void 0
  }

  if (!document.getElementById(id as string)) {
    console.error(`Player with ${id} did not found.`)
    return void 0
  }

  if (!location.protocol.match('https')) {
    setTimeout(function () {
      webSocket(PORT).catch((err: any) => console.error(err))
    }, 1e5)
  }

  // PLAYER ST4RT3R.
  const elm: any = document.getElementById(id as string)
  const self: any = {
    id: window.btoa(id as any),
    x: {
      status    : 'waiting...',
      nmf_path  : 'media_player.nmf',
      nmf_src   : '/static/media_player.nmf',
      src       : options.src || '',
      autoplay  : options.autoplay || false,
      muted     : options.muted || false
    }
  }

  const embed: any = createEmbedElement(self as any)
  elm.appendChild(embed)

  self.module = embed
  self.module.command = function () {
    let cmd = []
    for (let i = 0; i < arguments.length; i++) {
      cmd.push(arguments[i])
    }
    self.module.postMessage(cmd)
  }

  // Request the offsetTop property to force a relayout. As of Apr 10, 2014    
  // this is needed if the module is being loaded on a Chrome App's    
  // background page (see crbug.com/350445).    
  self.module.offsetTop

  // Controller function groups.
  self.play = function () {
    if (self.x.status !== 'playing') {
      self.module.command('open', self.x.src)
    }
    self.module.command('play', '0')
  }

  self.pause = function () {
    self.module.command('pause', '0')
    self.x.status = 'paused'
  }

  self.stop = function () {
    self.module.command('stop', '0')
  }

  self.muted = function (muted: boolean) {
    self.module.command('setvolume', muted ? '0.0' : '1.0')
  }

  self.src = function (src: string) {
    if (self.x.autoplay) {
      self.module.command('open', src || self.x.src)
    } else {
      self.stop()
    }
  }

  self.playerDidLoad = function () {
    self.src(self.x.src)
  }

  self.moduleDidLoad = function () {
    self.module.command('setversion', VERSION)
    self.module.command('setautoreconnect', '1')
    self.module.command('setavsync', '1')
    self.module.command('setlatency', '14400')
    self.module.command('setconnection_udp', '1')
    self.module.command('setvolume', self.x.muted ? '0.0' : '1.0')

    // if (location.protocol.match('https')) {
    //   self.connectToApp()
    // } else {
    //   self.module.command('startwebsclient', PORT)
    // }

    self.module.command('startwebsclient', PORT)
  }

  self.connectToApp = function () {
    self.app = window.chrome.runtime.connect('hncknjnnbahamgpjoafdebabmoamcnni')
    self.app.name = id

    // On Disconnect.
    self.app.onDisconnect.addListener(function () {
      self.module.command('stopnativeclient', `@${self.app.name}`)
      self.app = undefined
    })

    // On Message.
    self.app.onMessage.addListener(function (e: any) {
      if (
        e !== undefined && 
        e.id === undefined && 
        e[0] !== undefined && 
        e[0].charAt(0) === '@'
      ) {
        if (self.module.postMessage === undefined) {
          self.app.disconnect()
        } else {
          self.module.postMessage(e)
        }
      }
      else if (e !== undefined && e.cmd === 'getversionapp') {
        if (e.data.indexOf('VERSION_APP') === 0) {
          self.x.versionapp = e.data.split(' ')[1]

          self.module.command('setappversion', self.x.versionapp)
          self.module.command('startnativeclient', `@${self.x.port.name}`)
          self.playerDidLoad()
        } else {
          console.log(`Player ${id} Invalid VERSION_APP msg.data=${e.data}`)
        }
      } else {
        console.log(`Player ${id} getversionapp unknown msg=${e}`)
      }
    })

    self.app.postMessage({
      id  : self.app.name,
      cmd : 'getversionapp',
      data: ''
    })
  }

  self.handleMessage = function (e: any) {
    if (e === undefined || e.data === undefined) {
      return void 0
    }

    if (e.data[0] !== undefined && e.data[0].charAt(0) === '@') {
      if (self.m.port !== undefined) {
        self.m.port.postMessage(e.data)
      }
    }
    else if (e.data.match('PLAYER_INITED')) {
      self.moduleDidLoad()
    }
    else {
      if (e.data.match('VERSION_APP')) {
        self.x.versionapp = e.data.split(' ')[1]
        self.x.status = 'ready'
        self.playerDidLoad()
      }
      else if (e.data.match('MEDIA_ERR_URL')) {
        self.x.status = 'ERR_URL'
      }
      else if (e.data.match('MEDIA_ERR_NETWORK')) {
        // Problem with network.
        self.x.status = 'ERR_NETWORK'
      }
      else if (e.data.match('MEDIA_ERR_SOURCE')) {
        // Problem with source.
        self.x.status = 'ERR_SOURCE'
      }
      else if (e.data.match('MEDIA_ERR_CARRIER')) {
        // Problem with carrier.
        self.x.status = 'ERR_CARRIER'
      }
      else if (e.data.match('MEDIA_ERR_AUDIO')) {
        // Problem with audio.
        self.x.status = 'ERR_AUDIO'
      }
      else if (e.data.match('MEDIA_ERR_VIDEO')) {
        // Problem with video.
        self.x.status = 'ERR_VIDEO'
      }
      else if (e.data.match('MEDIA_ERR_BANDWIDTH')) {
        // Problem with bandwidth.
        self.x.status = 'ERR_BANDWIDTH'
      }
      else if (e.data.match('MEDIA_ERR_DECODER')) {
        self.x.status = 'ERR_DECODER'
      }
      else if (e.data.match('PLAYER_CONNECTING')) {
        self.x.status = 'connecting'
      }
      else if (e.data.match('PLAYER_PLAYING')) {
        self.x.status = 'playing'
      }
      else if (e.data.match('PLAYER_STOPPING')) {
        self.x.status = 'stoping'
      }
      else if (e.data.match('PLAYER_STOPPED')) {
        self.x.status = 'stoped'
      }
      else if (e.data.match('PLAYER_PAUSED')) {
        self.x.status = 'paused'
      }
    }

    // Callback.
    if (options.callback && isFunction(options.callback)) {
      const xs = ['ready', 'connecting', 'playing', 'paused', 'stoped']
      if (xs.indexOf(self.x.status) > -1) {
        options.callback({
          status: self.x.status,
          data  : e.data
        })
      }
    }

    /**
     * Log Rendering....
     */
    if (options.hasOwnProperty('log') && options.log) {
      console.log({
        log: e.data
      })
    }
  }

  self.handleError = function () {
    console.error('handleError!!')
  }

  self.handleCrash = function () {
    console.info('handleCrashed')
  }

  // self.module.addEventListener('load', self.moduleDidLoad, true)
  self.module.addEventListener('message', self.handleMessage, true)
  self.module.addEventListener('error', self.handleError, true)
  self.module.addEventListener('crash', self.handleCrash, true)

  return self as any
}

// export all selector.
export {
  Playback,
  Playback as playback,
  isIncognito as incognitoMode,
  isNotChrome,
  isNotXPnacl
}